export default function FeedSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      {[1, 2, 3]?.map((i) => (
        <div
          key={i}
          className="card-base p-5"
          style={{ opacity: 1 - i * 0.2 }}
        >
          {/* Header */}
          <div className="flex items-start gap-3 mb-4">
            <div className="skeleton w-10 h-10 rounded-full shrink-0" />
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <div className="skeleton h-4 w-28 rounded" />
                <div className="skeleton h-3 w-16 rounded" />
              </div>
              <div className="flex items-center gap-2">
                <div className="skeleton h-5 w-16 rounded" />
                <div className="skeleton h-5 w-14 rounded" />
                <div className="skeleton h-5 w-12 rounded" />
                <div className="skeleton h-5 w-16 rounded" />
              </div>
            </div>
          </div>

          {/* Caption */}
          <div className="mb-4 space-y-2">
            <div className="skeleton h-3.5 w-full rounded" />
            <div className="skeleton h-3.5 w-4/5 rounded" />
          </div>

          {/* Price grid */}
          <div className="grid grid-cols-4 gap-2 mb-4">
            {[1, 2, 3, 4]?.map((j) => (
              <div
                key={j}
                className="p-3 rounded-xl"
                style={{ background: 'var(--bg-sunken)' }}
              >
                <div className="skeleton h-3 w-12 rounded mx-auto mb-2" />
                <div className="skeleton h-4 w-16 rounded mx-auto" />
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 pt-3 border-t" style={{ borderColor: 'var(--border-subtle)' }}>
            <div className="skeleton h-8 w-16 rounded-lg" />
            <div className="skeleton h-8 w-16 rounded-lg" />
            <div className="skeleton h-8 w-10 rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}